module.exports = __webpack_public_path__ + "gamecode/img/ztmslg_favicon.png?726d6269";